import { Steps } from "antd";
import styled from "styled-components";

export const StyledSteps = styled(Steps)`
    .ant-steps-item-title::after {
        top: 16px !important;
        background-color: ${({ theme }) =>
            theme.secondaryBorderColor} !important;
    }

    .ant-steps-item-tail {
        pointer-events: none;
    }

    .ant-steps-item-icon {
        margin: 0 !important;
        width: 32px !important;
        height: 32px !important;
        border-radius: 50% !important;
    }

    .ant-steps-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        width: 100%;
        height: 100%;

        svg {
            font-size: 16px;
        }
    }

    .ant-steps-item-wait .ant-steps-item-icon {
        background: ${({ theme }) => theme.secondaryBorderColor} !important;

        .ant-steps-icon {
            color: ${({ theme }) => theme.secondaryTypographyColor} !important;
        }
    }

    .ant-steps-item-finish .ant-steps-item-icon {
        background: ${({ theme }) => theme.successTypographyColor} !important;

        .ant-steps-icon {
            color: ${({ theme }) => theme.colors.white} !important;
        }
    }

    .ant-steps-item-process .ant-steps-item-icon,
    .ant-steps-item-active .ant-steps-item-icon {
        background: ${({ theme }) =>
            theme.additionalTypographyColor} !important;

        .ant-steps-icon {
            color: ${({ theme }) => theme.colors.white} !important;
        }
    }
`;

export const StyledStepsContainer = styled.div`
    padding: 8px 16px;
    border-radius: 8px;
    background: ${({ theme }) => theme.primaryBackground};
`;
